<template>
  <div class="app-news">
    <div class="news-title">
      <h2>{{ $t('news.title') }}</h2>
    </div>
    <div class="news-infos" >
      <el-table :data="newsData" stripe  >
        <el-table-column type="index" width="70" label="序号" align="center"></el-table-column>
        <el-table-column prop="titnewsTitlele" label="标题" align="left">
          <template slot-scope="{row}">
            <el-link :href="`/newsDetail/${row.newsId}`" type="primary">{{ row.newsTitle|ellipsis(40) }}</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="newsType" label="资讯类型" width="160px" align="center">
          <template slot-scope="{row}">
            {{STOCK_TYPE[row.newsType]}}
          </template>
        </el-table-column> -->
        <el-table-column prop="createdTime" label="创建时间" width="190px" align="center"></el-table-column>

      </el-table>
      <div style="float: right">
        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="searchForm.pageNumber"
          :limit.sync="searchForm.pageSize"
          @pagination="handleSearch"
          >
          </pagination>
      </div>
    </div>
  </div>
</template>

<script>
const STOCK_TYPE = {
  0: '公司新闻',
  1: '政策法规'
}
export default {
  data() {
    return {
      STOCK_TYPE,
      searchForm: {
        pageNumber: 1,
        pageSize: 20
      },
      total: 10,
      newsData: []
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      this.$axios.get('/api/news/findNewsPageList', this.searchForm).then(res => {
        if (res.data.code = 200) {
          this.newsData = res.data.result.records || []
        }
      });
    },
    handleClick(id) {
      debugger
      this.$router.push(`/newsDetail/${id}`);
    }
  }
}
</script>

<style scoped lang="scss">
.app-news {
  padding: 70px 130px;
  min-height: 600px;
  background-color: #fff;
}
.app-news .news-title {
  text-align: center;
  color: dodgerblue;
}
.app-news .news-infos {
    flex: 1;
    height: 100%;
    margin-top: 2.5rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .lang{
      font-size: 0.191rem;
      line-height: 18px;
      color: #000;

    }
    .author{

      padding-top:6px;
      font-size: 0.191rem;
      color: #000;
      width: 100%;
      text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/News.vue